<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 860px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="id" :label="$t('attributes.id')">
              {{ form.id }}
            </form-group>
            <form-group
              horizontal
              name="name"
              :label="$t('attributes.area_name')"
            >
              {{ form.area.code }}{{ form.area.name }}
            </form-group>
            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch
                v-model="form.status"
                name="status"
                true-value="Y"
                false-value="N"
              ></b-switch>
            </form-group>
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
            <form-group
              horizontal
              name="content"
              :label="$t('attributes.offer') + $t('attributes.content')"
            >
              <div class="content">
                <editor
                  ref="content_editor"
                  v-model="form.content"
                  image-type="Project"
                ></editor>
              </div>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.update') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'HoneyMoonAreaForm',
  components: { Editor },

  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.detail),

      sortOptions: [...Array(20).keys()].map(i => i + 1),
      formTitle: '修改蜜月線別'
    }
  },
  validations: {
    form: {
      id: { required },
      sort: { required },
      status: { required },
      area: {},
      content: {}
    }
  },
  watch: {
    detail(newDetail) {
      this.form = this.extractFormValues(newDetail)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        sort: data.sort,
        status: data.status,
        area: data.area,
        content: data.content
      }
    },
    async onSend() {
      this.form.content = this.$refs.content_editor.getData()

      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
